import Vue from "vue";
import notification from "./mixins/notification";
import dateFormat from "./mixins/dateFormat";
import gaurd from "./mixins/gaurd";

Vue.mixin(notification);
Vue.mixin(dateFormat);
Vue.mixin(gaurd);
